module.exports = __webpack_public_path__ + "img/fu6.cc410678.png";